module.exports = __webpack_public_path__ + "static/roman-58ac57b67930c74de145092ac96e5ef2.png";